import React, { lazy } from 'react';
import { TruckIcon, PackageIcon } from 'lucide-react';
export function BundleVisual() {
  return <section className="w-full bg-gradient-to-b from-emerald-50 to-white py-16 md:py-24" data-id="element-154">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        {/* Section heading */}
        <div className="text-center mb-12" data-id="element-156">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-157">
            <PackageIcon className="w-8 h-8 text-emerald-700" data-id="element-158" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900" data-id="element-159">
            The Complete Natural Healing Bundle
          </h2>
        </div>

        {/* Bundle Image */}
        <div className="max-w-2xl mx-auto mb-12" data-id="element-160">
          <div className="overflow-hidden rounded-2xl shadow-2xl ring-1 ring-stone-200" data-id="element-161">
            <img src="https://cdn.magicpatterns.com/uploads/itAo1bFj7EQWwx25cQmWrE/Herbal_remedy_guides_and_natural_ingredients.png" alt="The Complete Natural Healing Bundle" className="w-full h-auto object-cover" loading="lazy" data-id="element-162" />
          </div>
        </div>

        {/* Value Breakdown Card */}
        <div className="max-w-lg mx-auto mb-10" data-id="element-163">
          <div className="bg-white rounded-2xl shadow-lg border-2 border-emerald-200 overflow-hidden" data-id="element-164">
            {/* Card header */}
            <div className="bg-emerald-700 px-8 py-4 text-center" data-id="element-165">
              <p className="text-emerald-100 text-sm font-semibold uppercase tracking-wide" data-id="element-166">
                What's Included
              </p>
            </div>

            <div className="p-6 md:p-8 space-y-4" data-id="element-167">
              <div className="flex items-center justify-between py-2" data-id="element-168">
                <span className="text-stone-800 font-medium" data-id="element-169">
                  The Natural Remedy Survival Guide
                </span>
                <span className="text-stone-500 text-sm font-semibold ml-4 flex-shrink-0" data-id="element-170">
                  $17
                </span>
              </div>
              <div className="flex items-center justify-between py-2" data-id="element-171">
                <span className="text-stone-800 font-medium" data-id="element-172">
                  Herbal First Aid — Natural Emergency Toolkit
                </span>
                <span className="text-stone-500 text-sm font-semibold ml-4 flex-shrink-0" data-id="element-173">
                  $17
                </span>
              </div>
              <div className="flex items-center justify-between py-2" data-id="element-174">
                <span className="text-stone-800 font-medium" data-id="element-175">
                  The Backyard Herbal Medicine Garden
                </span>
                <span className="text-stone-500 text-sm font-semibold ml-4 flex-shrink-0" data-id="element-176">
                  $17
                </span>
              </div>

              <div className="border-t-2 border-stone-100 my-2" data-id="element-177"></div>

              <div className="flex items-center justify-between" data-id="element-178">
                <span className="text-stone-500 font-semibold" data-id="element-179">
                  Total Value:
                </span>
                <span className="text-stone-400 line-through text-lg" data-id="element-180">$51</span>
              </div>
              <div className="flex items-center justify-between" data-id="element-181">
                <span className="text-emerald-700 font-semibold" data-id="element-182">
                  You Save:
                </span>
                <span className="text-emerald-700 font-bold text-lg" data-id="element-183">$34</span>
              </div>

              <div className="border-t-2 border-emerald-100 my-2" data-id="element-184"></div>

              <div className="flex items-center justify-between bg-emerald-50 -mx-6 md:-mx-8 px-6 md:px-8 py-4 rounded-b-xl" data-id="element-185">
                <span className="text-stone-900 font-bold text-xl" data-id="element-186">
                  Today Only:
                </span>
                <span className="text-4xl font-extrabold text-emerald-700" data-id="element-187">
                  $17
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Upsell Teaser */}
        <div className="text-center max-w-md mx-auto" data-id="element-188">
          <div className="flex items-center justify-center gap-2 text-sm text-stone-500 italic" data-id="element-189">
            <TruckIcon className="w-4 h-4 flex-shrink-0" data-id="element-190" />
            <p data-id="element-191">
              Prefer a printed copy? After checkout you'll have the option to
              upgrade to the physical edition delivered to your door.
            </p>
          </div>
        </div>
      </div>
    </section>;
}